export default __webpack_public_path__ + "static/media/572.4101a370.png";